import PropTypes from 'prop-types';
import { Button, Tooltip } from '@mui/material';
import { IconPencil } from '@tabler/icons-react';
import { FormattedMessage } from 'react-intl';

const EditActionButton = ({
  disabled = false,
  onClick,
  id,
  tooltip = <FormattedMessage id="edit" defaultMessage="Edit" />,
  iconSize = 17
}) => (
  <Tooltip
    title={tooltip}
    arrow
    placement="top"
    disableInteractive
    PopperProps={{
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, -10]
          }
        }
      ]
    }}
  >
      <Button
        variant="text"
        disableElevation
        disabled={disabled}
        onClick={onClick}
        id={id}
        sx={{
          px: 0,
          minWidth: 25,
          mr: 0.5,
          color: 'grey.800',
          '&:hover': {
            backgroundColor: 'transparent'
          }
        }}
      >
        <IconPencil size={iconSize} stroke={1.5} />
      </Button>
  </Tooltip>
);

EditActionButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  tooltip: PropTypes.node,
  iconSize: PropTypes.number
};

export default EditActionButton;